var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.label))]),_c('v-card-actions',[_c('div',{staticClass:"flex-grow-1"}),_vm._t("default"),_c('div',{staticClass:"flex-grow-1"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }